const tooltips = {
  temppwd: 'A mezőben megadott ideiglenes jelszót az adott felhasználónak az első bejelentkezésekor meg kell változtatnia.'
};

export default function getTooltip(name) {
  return tooltips[name];
}
